const timeChoose = [
  { value: "now_month", label: "BULAN INI" },
  { value: "now_year", label: "TAHUN INI" },
  { value: "last_year", label: "TAHUN KEMARIN" },
  { value: "five_years_ago", label: "LIMA TAHUN LALU" },
]
module.exports = {
  timeChoose
}